/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FileManagementAddFileUploadRequest } from "../models/FileManagementAddFileUploadRequest";
import type { FileManagementAddFileUploadResponseApiRespoonse } from "../models/FileManagementAddFileUploadResponseApiRespoonse";
import type { FileManagementDetailFileRequest } from "../models/FileManagementDetailFileRequest";
import type { FileManagementDetailFileResponseApiRespoonse } from "../models/FileManagementDetailFileResponseApiRespoonse";
import type { FileManagementEditFileRequest } from "../models/FileManagementEditFileRequest";
import type { FileManagementEditFileResponseApiRespoonse } from "../models/FileManagementEditFileResponseApiRespoonse";
import type { FileManagementListFileRequest } from "../models/FileManagementListFileRequest";
import type { FileManagementListFileResponseApiRespoonse } from "../models/FileManagementListFileResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class FileManagementService {
  /**
   * List file
   * @param requestBody
   * @returns FileManagementListFileResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static groupAdminFiles(
    requestBody: FileManagementListFileRequest
  ): CancelablePromise<FileManagementListFileResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/group_admin/files",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Detail file
   * @param requestBody
   * @returns FileManagementDetailFileResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static groupAdminFilesDetail(
    requestBody: FileManagementDetailFileRequest
  ): CancelablePromise<FileManagementDetailFileResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/group_admin/files/detail",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Edit file
   * @param requestBody
   * @returns FileManagementEditFileResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static groupAdminFilesEdit(
    requestBody: FileManagementEditFileRequest
  ): CancelablePromise<FileManagementEditFileResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/group_admin/files/edit",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Add new file upload
   * @param requestBody
   * @returns FileManagementAddFileUploadResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static groupAdminFilesAddFileUpload(
    requestBody: FileManagementAddFileUploadRequest
  ): CancelablePromise<FileManagementAddFileUploadResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/group_admin/files/add-file-upload",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
